import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'

import WelcomeHeader from '../../components/organisms/WelcomeHeader'
import './forgetPassword.css'
import CustomInput from '../../components/atoms/Inputs/CustomInput'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import { request } from '../../Utils/Request'
import { apiEndPoint } from '../../Utils/Redux/Store/apiEndpoint'
import { useFormik, Formik } from 'formik'
import { useSnackbar } from 'notistack'
import forgotPasswordSchema from './forgotPasswordSchema'
import { useTranslation } from 'react-i18next'
const forget_password = () => {
    const history = useHistory()
    const { t } = useTranslation()
    const [emailValue, setEmailValue] = useState({
        email: '',
    })

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()

    const formik = useFormik({
        initialValues: emailValue,
        enableReinitialize: true,
        validationSchema: forgotPasswordSchema,
        onSubmit: async (values, actions) => {
            try {
                const data = {
                    email: values.email,
                }
                const res = await request('post', apiEndPoint.forgotpassword, data)

                if (res.data.success === 'yes') {
                    enqueueSnackbar(res.data.message, { variant: 'success' })
                    setEmailValue({ email: '' })
                    actions.setSubmitting(false)
                    actions.resetForm({
                        values: {
                            email: '',
                        },
                    })
                } else if (res.data.success === 'no') {
                    enqueueSnackbar(res.data.message, { variant: 'error' })
                }
            } catch (error) {
                console.log(error)
            }
        },
    })

    const handleBackLogin = () => {
        history.push('/login')
    }
    return (
        // <WelcomeHeader>
        //     <div className="forgot-password">
        //         <h5 className="light-white my-3 welcome-heading">Welcome to Coach & Gavel !</h5>
        //         <div className="forgot-container-area">
        //             <h4 className="light-white">Forgot Password</h4>
        <div className="mobile-signup row m-0">
            <div className=" col-lg-6 col-12 login-content-area">
                <div className="signup-area-content">
                    <h2 className="text-left light-white mb-3">{t('forgot_password')}</h2>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="forgot-password-content">
                            <CustomInput
                                label={t('Email')}
                                type="text"
                                inputClassName="input-login login-user-name"
                                labelClass="login-user-name-label light-white"
                                placeholder={t('Email')}
                                name="email"
                                onChange={formik.handleChange}
                                value={formik.values.email}
                            />
                            {formik.errors.email ? (
                                <p className="err">{formik.errors.email}</p>
                            ) : null}

                            <PrimaryButton
                                customClassName="login-confirm-btn"
                                label="Send Reset Password Link"
                                type="submit"
                            />
                            <div className="forgot-password-button">
                                <Link to="/login">
                                    <div className="back-to-login">
                                        <span className="light-white">Back to Login </span>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className="col-lg-6 col-12 p-0 borderRight">
                <div className="login-car-image">
                    <div className="car-container">
                        {/* <div className="garvel-logo">
                        <Link to="/">
                            <img
                                src="/assets/svg/gavel-logo.svg"
                                alt="gavel-logo"
                                className="garvel-logo-image"
                            />
                        </Link>
                    </div> */}
                        <div className="car-image-contents">
                            <h4 className="light-black">{t('information_privacy')}</h4>
                            <p className="light-black">{t('your_informationn_safe')}</p>
                        </div>
                        {/* <div className="car-image-contents bottom2">
                        <h4 className="light-black">{t('quick_easy')}</h4>
                        <p className="light-black">{t('set_your_car')}</p>
                    </div>
                    <div className="car-image-contents bottom3">
                        <h4 className="light-black"> {t('do_you_need')}?</h4>
                        <p className="light-black">
                            {t('call_sms')} <a href="tel:+46 728 552 329">+46 728 552 329&nbsp;</a>
                            {t('via_chat')}
                        </p>
                    </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default forget_password
